  <template>
  <v-container>
    <div class="mt-4">
      <h1 class="text-center">Créer un compte</h1>
      <div class="d-flex">
        <v-spacer />
        <v-form ref="form" class="login">
          <v-fade-transition mode="out-in">
            <div v-if="formulaire">
              <v-card-text>
                <p>
                  Les informations de votre compte seront utilisées pour
                  pré-remplir vos demandes.
                </p>
                <a-creation-utilisateur-row v-model="info" />
              </v-card-text>
              <v-card-text>
                <p>Veuillez prouver que vous n'êtes pas un robot.</p>
                <a-captcha-sheet v-model="captcha" service="oauth2" />
              </v-card-text>
              <v-card-text class="d-flex">
                <router-link to="/accueil">Annuler</router-link>
                <v-spacer />
                <v-btn data-testid="creer" @click="creer" :loading="working" color="primary">
                  Créer
                </v-btn>
              </v-card-text>
            </div>
            <div v-else>
              <v-card-text>
                <p>
                  Un courriel a été envoyé à l'adresse saisie, veuillez le
                  consulter pour terminer la création de votre compte.
                </p>
              </v-card-text>
            </div>
          </v-fade-transition>
        </v-form>
        <v-spacer />
      </div>
    </div>
  </v-container>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import { utilisateurCycleService } from "@/services";
import { mapGetters } from "vuex";

export default {
  mixins: [makeRemoteWorker()],
  data() {
    return {
      info: {
        motPasse: "",
        nom: "",
        prenom: "",
        email: "",
        civilite: "M",
        adresse: "",
        complementAdresse: "",
        codePostal: "",
        ville: "",
      },
      captcha: {},
      formulaire: true,
    };
  },
  mounted() {
    this.info.email = this.initEmail;
  },
  computed: {
    ...mapGetters({ initEmail: "login/email" }),
  },
  methods: {
    creer() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          const info = this.info;
          const creer = {
            infos: {
              nom: info.nom,
              prenom: info.prenom,
              email: info.email,
              civilite: info.civilite,
              adresse: info.adresse,
              complementAdresse: info.complementAdresse,
              codePostal: info.codePostal,
              ville: info.ville,
            },
            motPasse: info.motPasse,
          };
          return utilisateurCycleService.creer(creer, this.captcha);
        },
        callback() {
          this.formulaire = false;
        },
        successText: "La demande de création a été transmise",
        errorText: "Erreur durant la demande de création",
      });
    },
  },
};
</script>
